import Product from '@vue-storefront/core/modules/catalog/types/Product';
import { CustomOption, OptionValue } from '@vue-storefront/core/modules/catalog/types/CustomOption';

const sortOrder = (a: number | undefined, b: number | undefined): number =>
  (a ?? 0) - (b ?? 0);

/**
 * Sort custom_options by sort_order, and each option's values by sort_order.
 * Mutates product in place. Safe to call when custom_options is missing or empty.
 */
export default function sortCustomOptions (product: Product): void {
  const options = product.custom_options;
  if (!options || !Array.isArray(options) || options.length === 0) return;

  options.sort((a: CustomOption, b: CustomOption) => sortOrder(a.sort_order, b.sort_order));

  options.forEach((option: CustomOption) => {
    const values = option.values;
    if (!values || !Array.isArray(values) || values.length === 0) return;
    (values as OptionValue[]).sort((a, b) => sortOrder(a.sort_order, b.sort_order));
  });
}
